/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import {BULK_RESIZE_IMAGES} from '@/graphql'
import apollo from './apollo';

const actions = {
  setStudent ({ commit }, payload) {
    commit('setStudent', payload)
  },
  setNewsletterJson ({ commit }, payload) {
    commit('setNewsletterJson', payload)
  },
  setBuilderMenu ({ commit }, payload) {
      commit('setBuilderMenu', payload)
    },
  setResizeImgs ({ commit }, payload) {

    // spliceAry(payload.imgs,payload.width)

    // function spliceAry(imgs,width){
    // let ImgArray = imgs.splice(0, 5);
    // if(ImgArray.length>0){
    //    sendResizeImge(ImgArray,width) 
    //  }
    //  if(imgs.length>0){
    //    spliceAry(imgs,width)
    //  }
    // }
    sendResizeImge(payload.imgs,payload.width)
     function sendResizeImge(imgs,width){
        const elements = imgs.splice(0, 5);  
         commit('setStartImg', elements)
          apollo.mutate({
             mutation: BULK_RESIZE_IMAGES,
             variables: {
                   id: elements,
                   width:width
             }
           })
           .then(response => {
            //  console.log(response)
               if(response.data.bulkResizeImges.status==='Success'){
                    commit('setCompleteImg', elements)
                    if(imgs.length>0){
                      sendResizeImge(imgs,width)
                    }
                }
                
                   })
     }

  },
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },
  updateAppTitle ({ commit }, val) {
    commit('UPDATE_APP_TITLE', val)
  },
  UpdateAppLogo ({ commit }, imgSrc) {
    commit('UPDATE_APP_LOGO', imgSrc)
  },
  updateAppLoginShowImg ({ commit }, val) {
    commit('UPDATE_APP_SHOW_LOGIN_IMG', val)
  },
  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  }
}

export default actions
